<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />

      <!-- Alert Dialog Starts  -->
      <v-alert v-model="alert_dialog.status" :type="alert_dialog && alert_dialog.type" elevation="1" id="alert_dialog" 
        dismissible
        transition="slide-y-reverse-transition"
        border="bottom"
      >
        <span v-html="alert_dialog.message"></span>
      </v-alert>
      <!-- Alert Dialog Ends -->

  </v-app>
</template>

<script>
import { EventBus } from '@/event_bus';
export default {
  name: 'App',

  components: {
    
  },

  data() {
    return {
      alert_dialog: {
      message: '',
      status: false,
      type: 'success'
    },
    };
  },

  created() {
    this.activateEventListener();
  },
  

  methods: {
    activateEventListener(){
      EventBus.$on('showAlert', (alert) => {
        try {
          if(alert && alert.status && alert.message && alert.type){
              this.alert_dialog.status = alert.status;
              this.alert_dialog.message = alert.message;
              this.alert_dialog.type = alert.type;
              setTimeout(() => {
                this.alert_dialog.status = false;
              }, 5000);
          }
        } catch (error) {
          console.log("");
        }
      })
    },
  },

};
</script>

<style>
#alert_dialog{
  position: fixed;
  bottom: 0;
  left: 10px;
  z-index: 2000;
}
</style>